import React from 'react';
import "./Home.scss"
import BaseMenuPrincipal from '../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal';
import { HomeComponent } from '../../../componentes/HomeComponent/HomeCOmponent';

const App = () => {
  return (
    <main>
      <HomeComponent />
    </main>
  );
}

export default App;
